import {useAuth} from '~/auth/AuthContext';
import React, {useEffect} from 'react';
import {pushGtmEvent} from '~/utils/analytics';

export const AnalyticsTracking = ({children}: {children: React.ReactNode}) => {
  const {user, isLoading} = useAuth();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    pushGtmEvent({
      event: 'lab_async_load',
      logged_in: Boolean(user)
    });
  }, [isLoading]);

  return <>{children}</>;
};
